import { Injectable } from '@angular/core'
import { catchError, Observable, of, shareReplay } from 'rxjs'
import { ApiService } from './api.service'
import { Specialty } from '../store/interfaces/specialty'

@Injectable({
  providedIn: 'root',
})
export class SpecialtiesService {
  private apiUrl = `specialties`
  private cachedSpecialties$: Observable<Specialty[]> | null = null
  private cachedAt = 0
  private readonly cacheTtlMs = 5 * 60 * 1000

  constructor(private apiService: ApiService) {}

  getSpecialties(forceRefresh = false): Observable<Specialty[]> {
    const now = Date.now()
    if (!forceRefresh && this.cachedSpecialties$ && now - this.cachedAt < this.cacheTtlMs) {
      return this.cachedSpecialties$
    }

    this.cachedAt = now
    this.cachedSpecialties$ = this.apiService.get<Specialty[]>(`${this.apiUrl}`).pipe(
      shareReplay({ bufferSize: 1, refCount: false }),
      catchError((err) => {
        this.cachedSpecialties$ = null
        this.cachedAt = 0
        console.error('Error cargando especialidades', err)
        return of([])
      }),
    )
    return this.cachedSpecialties$
  }
}
